import { render } from "./404.vue?vue&type=template&id=0c099974&scoped=true"
const script = {}

import "./404.vue?vue&type=style&index=0&id=0c099974&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c099974"]])

export default __exports__